export const FILTER_BOOKINGS = 'filter-bookings';

export default function filterBookings({ filter }) {
  return {
    type: FILTER_BOOKINGS,
    payload: {
      bookingsFilter: filter,
    },
  };
}
